import { render, staticRenderFns } from "./GeneralCardItemGroup.vue?vue&type=template&id=4dc492c1&"
import script from "./GeneralCardItemGroup.vue?vue&type=script&lang=js&"
export * from "./GeneralCardItemGroup.vue?vue&type=script&lang=js&"
import style0 from "./GeneralCardItemGroup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VCard,VCol,VContainer,VIcon,VItem,VItemGroup})
